class BestPlacesCarousel extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('[data-best-places-card]'));
    if (this.cards.length <= 1) return;

    this.activeIndex = 0;
    this.holdDuration = 2000;
    this.mediaQuery = window.matchMedia('(max-width: 749px)');

    this.handleMediaChange = this.handleMediaChange.bind(this);
    this.mediaQuery.addEventListener('change', this.handleMediaChange);
    this.applyStack();
    this.handleMediaChange();
  }

  handleMediaChange() {
    if (this.mediaQuery.matches) {
      this.start();
    } else {
      this.stop();
    }
  }

  applyStack() {
    const total = this.cards.length;
    this.cards.forEach((card, i) => {
      const depth = (i - this.activeIndex + total) % total;
      card.style.setProperty('--depth-y', `${depth * 5}px`);
      card.style.setProperty('--depth-scale', `${1 - depth * 0.025}`);
      card.style.setProperty('--depth-opacity', `${Math.max(1 - depth * 0.25, 0.45)}`);
      card.style.zIndex = total - depth;
      card.classList.toggle('is-active', depth === 0);
    });
  }

  start() {
    if (this.intervalId) return;
    this.intervalId = setInterval(() => {
      this.activeIndex = (this.activeIndex + 1) % this.cards.length;
      this.applyStack();
    }, this.holdDuration);
  }

  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  disconnectedCallback() {
    this.stop();
    this.mediaQuery.removeEventListener('change', this.handleMediaChange);
  }
}

customElements.define('best-places-carousel', BestPlacesCarousel);
